import React from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";


import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/Button";
import PageHeader from "../../components/PageHeader";
import { getTestData } from "../../store/actions";

const ReduxAndReduxSaga = (props) => {
  const dispatch = useDispatch();
  const { datas, isLoading, error } = useSelector((store) => store.Test);
  const getTest = (params) => {
    dispatch(getTestData({ offset: 0, limit: 2, aaa: '테스트입니다.', ...params }))
  }
  return (
    <div className="test-page">
      <PageHeader title="WeCake - Redux And Redux-saga" />

      <Card>
        <CardBody>
          <CardTitle>Redux And Redux-saga</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            redux 데이터
          </CardSubtitle>
          <div>
            TEST DATAS
            <br />
            <br />
            <br />
            <code>
              {isLoading ? 'Loading...' :
                error ? <>error.status : {error.status}, error.message : {error.message}</> :
                  JSON.stringify(datas)
              }
            </code>
          </div>
          <br />
          <Button onClick={() => getTest({
            delay: 3000
          })} color="green">테스트 데이터 딜레이 3초</Button>
          <br />
          <br />
          <Button onClick={() => getTest({
            delay: 2000, error: { status: 500, message: "테스트에러" }
          })} color="red">테스트 데이터 500 에러 요청</Button>
          <br />
          <br />
          <Button onClick={() => getTest({
            delay: 2000, error: { status: 400, message: "테스트에러" }
          })} color="red">테스트 데이터 400 에러 요청</Button>


        </CardBody>
      </Card>


    </div>
  );
};

export default ReduxAndReduxSaga;
